@if (!editMode || (editMode && fieldConfig.editReadOnly)) {
  <div>
    <!--    <span *ngIf="modelDate">{{modelDate}}</span>-->
    {{ formattedDate }}
  </div>
} @else {
  @if (internalFormGroup) {
    <div class="form-content">
      <app-form-field-date-time
        [formGroup]="internalFormGroup"
        [fieldConfig]="fromConfig"
        [data]="data?.from"
        [editMode]="editMode"
        [datePlaceholder]="'From date'"
        [timePlaceholder]="'From time'"></app-form-field-date-time>
      <app-form-field-date-time
        [formGroup]="internalFormGroup"
        [fieldConfig]="toConfig"
        [data]="data?.to"
        [editMode]="editMode"
        [datePlaceholder]="'To date'"
        [timePlaceholder]="'To time'"></app-form-field-date-time>
    </div>
  }
}
